/**
 * Shared stylesheet for printable income reports (A4 preview/debug view).
 */
export const REPORT_CSS_STYLE = `
body {
    margin: 0;
    font-family: "Helvetica Neue", Helvetica, Georgia, "Times New Roman", serif;
}

.report {
    color: black;
    background-color: white;
    padding: 20px 10px;
}

.report .title {
    margin-bottom: 10px;
}

.report h1 {
    margin: 0px 0px 5px 0px;
    font-size: 20px;
}

.report h1.small {
    font-size: 16px !important;
}

.report h2 {
    text-align: center;
    margin: 0px 0px 5px 0px;
    font-size: 18px;
}

.report .grid {
    display: block;
    position: relative;
    margin: 20px 0px;
    width: 100%;
}

.report .grid:after {
    content: "";
    display: table;
    clear: both;
}

.report .grid .column.left {
    width: 45%;
}

.report .grid .column.right {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 50%;
    margin: 0px auto;
}

.report .brief-box {
    display: block;
    margin-top: 15px;
    border: 1px solid #666;
}

.report .pie-box .chart-box {
    height: 220px;
    margin: 15px auto 0px auto;
}

.report upp-chart {
    display: block;
    width: 100%;
}

.report upp-chart img,
.report .chart-box img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
}

.report table {
    width: 100%;
    border-collapse: collapse;
}

.report table tr {
    border-bottom: 1px solid #666;
}

.report table tr td {
    padding: 10px 15px;
}

.report table tr td.right {
    text-align: right;
    max-width: fit-content;
}

.report table tr td .big {
    font-size: 120%;
    font-weight: bold;
}

.report table tr td .small {
    font-size: 80%;
    opacity: .8;
}

.report table tr.noline {
    border-bottom: none;
}

.report table tr.split td {
    text-align: center;
    border-right: 1px solid #666;
}

.report table tr.split td:last-child {
    border-right: none;
}

.report .leyend {
    display: block;
    margin: 3px auto 8px auto;
    height: 15px;
    width: 40px;
    border: 2px solid black;
}

.report .tickets {
    padding: 10px 0px;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.report .tickets table {
    font-size: 11px;
    width: 100%;
    border: 1px solid #ddd;
}

.report .tickets table tr {
    border-bottom: none !important;
}

.report .tickets table tr:nth-child(odd) {
    background-color: #ddd;
}

.report .tickets table td {
    padding: 3px 5px;
}
`.trim();

/**
 * Returns the CSS payload used for printable report preview documents.
 */
export const reportStyle = (): string => {
    return REPORT_CSS_STYLE;
};
